import {css} from '@emotion/css';
import {mq, Breakpoints} from '@fo/shared/styles/mixins';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';

export default {
  componentWrapper: (label: boolean): string => css`
    label: navigationLinksGroup__componentWrapper;
    display: flex;
    flex-direction: column;
    ${mq(Breakpoints.DESKTOP)} {
      padding-top: ${!label ? '0' : '38px'};
    }
  `,
  groupLabel: css`
    label: navigationLinksGroup__groupLabel;
    color: ${colours.brand.SECONDARY};
    font-size: ${fonts.size.H4};
    line-height: ${fonts.lineHeight.HEADING};
    display: block;
    margin-top: 0px;
    font-weight: ${fonts.weight.SEMI_BOLD};
    min-height: 18px;
    margin-bottom: ${spacing.XS};
  `,
  linkListItem: css`
    label: navigationLinksGroup__linkListItem;
    margin-bottom: ${spacing.XXS};
  `,
  link: css`
    label: navigationLinksGroup__link;
    text-decoration: none;
    transition: opacity 100ms;
  `,
  linkLabel: css`
    label: navigationLinksGroup__linkLabel;
    display: block;
    margin-top: 0px;
    margin-bottom: ${spacing.XXS};
    color: ${colours.font.BLACK};
    font-size: ${fonts.size.H4};
    font-weight: ${fonts.weight.SEMI_BOLD};
    line-height: ${fonts.lineHeight.HEADING};
  `,
  linkDescription: css`
    label: navigationLinksGroup__linkDescription;
    margin-bottom: ${spacing.XXS};
    color: ${colours.font.LIGHT_GRAY};
  `,
};
